const statusManipulation = {
  title1: 'Inactive equipment',
  title2: 'Equipment under maintenance',
  title3: 'Equipment ready to use',
  title4: 'Equipment not ready to use',
  title5: 'Status is being consolidated. Reload the page in a moment',
  title6: 'Equipment ready but in adequation',
  title7: 'Equipment with no services'
};

export default statusManipulation;
